import { render, staticRenderFns } from "./DesenhoNumberView.vue?vue&type=template&id=024e2c32&scoped=true"
import script from "./DesenhoNumberView.vue?vue&type=script&lang=js"
export * from "./DesenhoNumberView.vue?vue&type=script&lang=js"
import style0 from "./DesenhoNumberView.vue?vue&type=style&index=0&id=024e2c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e2c32",
  null
  
)

export default component.exports